document.addEventListener('DOMContentLoaded', function() {
  const yesButton = document.querySelector('.age-btn.yes');
  const popupOverlay = document.querySelector('.popup-popup-overlay-newsletter');
  const noButton = document.querySelector('.age-btn.no');
  const closeButton = document.querySelector('.popup-popup-close-newsletter'); // Close button
  const popupContainer = document.querySelector('.popup-popup-container-newsletter'); // Popup container

  yesButton.addEventListener('click', function() {
    setTimeout(function() {
      popupOverlay.classList.add('active');
    }, 5000);
  });

  noButton.addEventListener('click', function() {
  });

 
  closeButton.addEventListener('click', function() {
    popupOverlay.classList.remove('active');
  });


  window.addEventListener('click', function(event) {
    if (!popupContainer.contains(event.target) && popupOverlay.classList.contains('active')) {
      popupOverlay.classList.remove('active');
    }
  });
});
